import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import ApiConfig from 'src/config/api-config';
import toast from 'react-hot-toast';

export interface DeleteProgramPlanPayload {
  docPath?: string;
  programId?: string;
  trainerId?: string;
  hideToast?: boolean;
}

export const useDeleteProgramPlan = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: DeleteProgramPlanPayload) => {
      const response = await axios.post(
        `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.TRAINER_DELETE_PROGRAM_PLAN}`,
        { data: payload },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      return response.data;
    },
    onSuccess: (data, variables) => {
      // Invalidate the query to fetch fresh data
      queryClient.invalidateQueries({ queryKey: ['trainer-program-plan-list'] });
      queryClient.invalidateQueries({ queryKey: ['clientWorkoutsTab'] });
      queryClient.invalidateQueries({ queryKey: ['clientProgramTab'] });
      queryClient.invalidateQueries({ queryKey: ['clientOverview'] });
      queryClient.invalidateQueries({ queryKey: ['overview'] });
      queryClient.invalidateQueries({ queryKey: ['trainer_get_client_overview'] });
      queryClient.removeQueries({ queryKey: ['clientWorkoutsTab'] });
      queryClient.removeQueries({ queryKey: ['clientProgramTab'] });
      queryClient.removeQueries({ queryKey: ['clientOverview'] });
      if (!variables.hideToast) {
        toast.success('Program deleted successfully');
      }
    },
    onError: (error) => {
      console.error('Failed to delete program', error);
      toast.error('Failed to delete program');
    },
  });
};
